module.exports = __webpack_public_path__ + "static/media/hdc-55-connect.29225f7d.png";